import { PayloadAction } from '@reduxjs/toolkit';
import { commandActions } from 'core/slices/commands';
import { EntityTypes } from 'constants/entities';
import { ICopyItem } from 'core/actions/admin/diagram';
import { Vector3Tuple } from 'three';
import { ActionEntityType } from 'types/domain/action';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { actionEditorSaga } from './saga';
import { updateViewerState } from 'core/slices/player';
import { Handles } from 'constants/handles';
import { flowActions } from 'core/slices/flow';

export interface IActionEditorState {
  dropId: number;
  draggingIn: boolean;
  draggingPos: boolean;
  drawId: number;
  drawing: boolean;
  position: Vector3Tuple;
  scale: Vector3Tuple;
  enabled: boolean;
  edit: IEditState;
}

export interface IEditState {
  text: boolean;
  feature: boolean;
  entities: boolean;
  mediaEdit: boolean;
  mediaSelect: boolean;
  voice: boolean;
  variable: boolean;
  newAction: boolean;
  quiz: boolean;
  handle?: Handles;
}

export interface IActionEditorItem {
  id: number;
  type: EntityTypes;
}

export interface IDrop {
  position: Vector3Tuple;
  scale?: Vector3Tuple;
  actionEntityType?: number;
}

const initialState: IActionEditorState = {
  dropId: null,
  draggingIn: false,
  draggingPos: false,
  drawId: null,
  drawing: false,
  position: null,
  scale: null,
  enabled: false,
  edit: {
    text: false,
    feature: false,
    mediaEdit: false,
    mediaSelect: false,
    variable: false,
    entities: false,
    newAction: false,
    quiz: false,
    handle: null,
    voice: false,
  },
};

const slice = createSlice({
  name: 'actionEditor',
  initialState,
  reducers: {
    draw(state, action: PayloadAction<number>) {
      state.drawId = action.payload;
      state.drawing = !!action.payload;
    },
    dragIn(state, action: PayloadAction<number>) {
      state.dropId = action.payload;
      state.draggingIn = !!action.payload;
    },
    dropIn(state, action: PayloadAction<number>) {
      state.draggingIn = false;
    },
    dragging(state, action: PayloadAction<boolean>) {
      state.draggingPos = action.payload;
    },
    drop(state, action: PayloadAction<IDrop>) {
      state.position = action.payload.position;
      state.scale = action.payload.scale;
      state.draggingIn = false;
      state.drawing = [ActionEntityType.SHAPE].includes(state.dropId);
    },
    point(state, action: PayloadAction<Vector3Tuple>) {
      state.position = action.payload;
    },
    enable(state, action: PayloadAction<boolean>) {
      state.enabled = action.payload;
    },
    edit(state, action: PayloadAction<Partial<IEditState>>) {
      state.edit = { ...initialState.edit, ...action.payload };
    },
    deselect() {},
  },
  extraReducers: builder => {
    // builder.addCase(commandActions.select, (state, action) => {
    //   state.enabled = action.payload.some(item => item.type === EntityTypes.ACTION_ENTITY);
    // });
    builder.addCase(flowActions.selectModNode, (state, action) => {
      state.edit = initialState.edit;
    });
  },
});

export const { actions: actionEditorActions, reducer } = slice;

export const useActionEditorSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: actionEditorSaga });
  return { actions: slice.actions };
};
